import { render, staticRenderFns } from "./order-invoice.vue?vue&type=template&id=b74ab3e6&scoped=true"
import script from "./order-invoice.vue?vue&type=script&lang=js"
export * from "./order-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74ab3e6",
  null
  
)

export default component.exports